/* eslint-disable react/react-in-jsx-scope */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Radio, RadioGroup, Typography } from "@mui/material";
import "./homepage-new.scss";
import CarouselHome from "../../common/components/carousel-home-component/carousel-home";
import ChatbotComponent from "../../common/components/chatbot-component/chatbot-component";
import FirstSectionHome from "./first-section";
import SeventhSectionHome from "./seventh-section";
import SecondSectionHome from "./second-section";
import FourthSectionHome from "./fourth-section";
import SixthSectionHome from "./sixth-section";
import FifthSectionHome from "./fifth-section";
import { useEffect, useMemo } from "react";
import { AlertComponent } from "../../common/components";
import { getCurrentUserDetails } from "../../common/routines/user-operations";
import { getUserProfileDetails, updateUserProfileFuneralDirector } from "../../api/userProfile.api";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSetLoading } from "../../common/hooks/appearance";
import { getCategories } from "../../api/admin/service-management";
import CloseIcon from "@mui/icons-material/Close";

export default function NewHome() {

  const currentUserDetails = useSelector(
    (state: { session: { userDetails: any, isLoggedIn: boolean } }) =>
      state.session.userDetails
  );
  const isLoggedIn = useSelector((state: any) => state.session.isLoggedIn);
  const userDetailStore = useSelector(
    (state: any) => state.session?.userDetails?.user,
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const [allCategories, setAllCategories] = useState<any[]>([]);
  const [isPaymentStatusPopupOpen, setIsPaymentStatusPopupOpen] =
    useState<boolean>(false);
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState<boolean>(false);
  const [isOrderConfirmedPopup, setIsOrderConfirmedPopup] = useState<boolean>(false);
  const [isOrderAlreadyConfirmedPopup, setIsOrderAlreadyConfirmedPopup] = useState<boolean>(false);

  const checkCartDetails = () => {
    try {
      const storedCartDetails = localStorage.getItem("cartDetails");
      if (!storedCartDetails) return;
      const cartDetails = JSON.parse(storedCartDetails);
      let path = cartDetails?.path || "";

      if (cartDetails?.id) {
        path = path.replace(":id", String(cartDetails.id));
      }

      if (path) {
        navigate(path);
      }
    } catch (error) { }
  };
  const checkPreneedPlannerCartDetails = () => {
    try {
      const planPackage = localStorage.getItem("planPackage");
      if (!planPackage) return;

      const planData = JSON.parse(planPackage);
      let path = planData?.path || "";

      if (planData?.plannerId) {
        path = path.replace(":id", String(planData.plannerId));
      }

      //path = path.replace("home/", "");

      if (path) {
        navigate(path);
      }
    } catch (error) { }
  };
  const fetchUserProfileDetails = async () => {
    try {
      setLoading(true);

      const response = await getUserProfileDetails();
      if (response?.data?.success) {
        const profileData = response.data.data;

        const userDetailsStr = localStorage.getItem("userDetails");

        if (userDetailsStr) {
          const userDetails = JSON.parse(userDetailsStr);

          const updatedUser = {
            ...userDetails.user,
            profile_photo:
              profileData?.profile_photo ?? userDetails.user?.profile_photo,
            first_name: profileData?.first_name ?? userDetails.user?.first_name,
            last_name: profileData?.last_name ?? userDetails.user?.last_name,
            email: profileData?.email ?? userDetails.user?.email,
            mobileNumber:
              profileData?.mobileNumber ?? userDetails.user?.mobileNumber,
            isFuneralDirector:
              profileData?.isFuneralDirector !== undefined
                ? profileData.isFuneralDirector
                : userDetails.user?.isFuneralDirector,
          };

          // update only if something actually changed
          const hasChanges =
            userDetails.user?.profile_photo !== updatedUser?.profile_photo ||
            userDetails.user?.first_name !== updatedUser?.first_name ||
            userDetails.user?.last_name !== updatedUser?.last_name ||
            userDetails.user?.email !== updatedUser?.email ||
            userDetails.user?.mobileNumber !== updatedUser?.mobileNumber ||
            userDetails.user?.isFuneralDirector !== updatedUser?.isFuneralDirector;

          if (hasChanges) {
            const updatedDetails = {
              ...userDetails,
              user: updatedUser,
            };

            localStorage.setItem(
              "userDetails",
              JSON.stringify(updatedDetails)
            );

            // Also update Redux with the latest data
            dispatch({
              type: "SESSION:UPDATE_USER_DETAILS",
              payload: {
                ...updatedUser,
              },
            });
          }
        }
      }
    } catch (error) {
      console.error("USER PROFILE GET FAILED::", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSaveRole = async () => {
    try {
      // Call API to update isFuneralDirector with required fields
      setLoading(true);
      const response = await updateUserProfileFuneralDirector({
        isFuneralDirector: selectedRole,
      });

      if (response.data?.success || response.data?.data?.id) {
        // Update redux with the selected role
        dispatch({
          type: "SESSION:UPDATE_USER_DETAILS",
          payload: {
            isFuneralDirector: selectedRole,
          },
        });

        // Fetch updated user profile details from server
        await fetchUserProfileDetails();

        setOpenRoleModal(false);
        setAlertMessage("Role updated successfully!");
        setAlertType("success");
        setAlertOpen(true);
        setTimeout(() => {
          setAlertOpen(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error updating role:", error);
      setAlertMessage("Failed to update role. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
      setTimeout(() => {
        setAlertOpen(false);
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCategories = async () => {
    try {
      const response = await getCategories({ type: "all" });
      if (response.data?.success) {
        setAllCategories(response.data.data?.data || []);
      }
    } catch (error) {
      console.error("FAILED TO FETCH CATEGORIES::", error);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("providerSearchText", "");
    sessionStorage.setItem("searchSuggestion", "");
    if (!location.state?.manualNav) {
      checkCartDetails();
      checkPreneedPlannerCartDetails();
    }
    fetchAllCategories();
    if (isLoggedIn) {
      fetchUserProfileDetails();
    } else {
      setLoading(false);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    // Check if user is logged in and isFuneralDirector is null, then show modal
    if (currentUserDetails?.user?.isFuneralDirector === null) {
      setOpenRoleModal(true);
    }
  }, [currentUserDetails]);

  useEffect(() => {
    if (localStorage.getItem(`userLogoutReason`) === "user:INACTIVITY") {
      setAlertMessage("Your session has expired due to inactivity.");
      localStorage.removeItem("userLogoutReason");
      dispatch({ type: 'SESSION:SET_AUTO_LOGOUT', payload: { userType: 'user', autoLogoutOfUser: false } });
      setAlertType("info");
      setAlertOpen(true);
      setTimeout(() => {
        setAlertOpen(false);
      }, 2000);
    }
  }, [currentUserDetails]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paymentStatus = params.get("payment-status");
    const orderConfirmed = params.get("order-confirmed");
    const orderAlreadyConfirmed = params.get("order-already-confirmed");

    if (paymentStatus === "true" || paymentStatus === "false") {
      setIsOrderConfirmedPopup(false);
      setIsOrderAlreadyConfirmedPopup(false);
      setIsPaymentSuccessful(paymentStatus === "true");
      setIsPaymentStatusPopupOpen(true);
    } else if (orderConfirmed === "true") {
      setIsOrderConfirmedPopup(true);
      setIsOrderAlreadyConfirmedPopup(false);
      setIsPaymentSuccessful(true);
      setIsPaymentStatusPopupOpen(true);
    } else if (orderAlreadyConfirmed === "true") {
      setIsOrderConfirmedPopup(false);
      setIsOrderAlreadyConfirmedPopup(true);
      setIsPaymentSuccessful(true);
      setIsPaymentStatusPopupOpen(true);
    }
  }, [location.search]);

  const handlePaymentStatusPopupClose = () => {
    setIsPaymentStatusPopupOpen(false);
    setIsOrderConfirmedPopup(false);
    setIsOrderAlreadyConfirmedPopup(false);
    navigate("/home", { replace: true });
  };

  const isOrderStatusPopup =
    isOrderConfirmedPopup || isOrderAlreadyConfirmedPopup;

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <Box className="homepage" sx={{ backgroundColor: "#fff" }}>
      {/* First Section: Search & Tabs */}
      <FirstSectionHome categories={allCategories} />

      {/* Second Section: Why MemorialGO */}
      <SecondSectionHome />

      {/* Third Section: Services Carousel */}
      <Box>
        <CarouselHome categories={allCategories} />
      </Box>

      {/* Fourth Section: Why Choose MemorialGo */}
      <FourthSectionHome />

      {/* Fifth Section: StepCards */}
      <FifthSectionHome />

      {/* Sixth Section: Emotional Reset */}
      <SixthSectionHome />

      {/* Seventh Section: Your Guide */}
      <SeventhSectionHome categories={allCategories} />

      {/* Chatbot component */}
      <Box
        sx={{
          position: "fixed",
          bottom: 8,
          right: 2,
          zIndex: 1000,
          display: "flex",
        }}
      >
        <ChatbotComponent />
      </Box>
      <Dialog
        open={isPaymentStatusPopupOpen}
        onClose={handlePaymentStatusPopupClose}
        fullWidth
        maxWidth="sm"
        BackdropProps={{
          sx: {
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0, 0, 0, 0.25)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#121212" }}>
            {isOrderConfirmedPopup
              ? "Order successful"
              : isOrderAlreadyConfirmedPopup
                ? "Order Already Confirmed"
              : isPaymentSuccessful
                ? "Payment Successful"
                : "Payment Failed"}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handlePaymentStatusPopupClose}
            sx={{ color: "#6A7282" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: "8px !important" }}>
          <Typography sx={{ color: "#4B4F50", fontSize: "16px", lineHeight: "24px" }}>
            {isOrderConfirmedPopup
              ? "Your order has been successfully placed. You will receive a confirmation email shortly."
              : isOrderAlreadyConfirmedPopup
                ? "This order has already been confirmed. No further action is needed."
              : isPaymentSuccessful
                ? "Your payment has been successfully completed. Your order is now confirmed."
                : "We couldn\u2019t process your payment. Please place a new order or contact the provider to receive a new payment link."}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: "16px 24px 20px 24px" }}>
          <Button
            variant="contained"
            onClick={handlePaymentStatusPopupClose}
            sx={{
              textTransform: "none",
              backgroundColor: "#EBD28D",
              color: "#212121",
              borderRadius: "8px",
              px: 3,
              "&:hover": {
                backgroundColor: "#E2C56F",
              },
            }}
          >
            Go to Home
          </Button>
        </DialogActions>
      </Dialog>
      {/* ===== ROLE POPUP ===== */}
      <Dialog
        open={openRoleModal}
        disableEscapeKeyDown
        onClose={() => { }}
        // maxWidth="md"
        fullWidth
        PaperProps={{
          elevation: 0, // 🚨 remove default shadow
          sx: {
            borderRadius: "8px",
            padding: "10px 20px 10px 12px",
            border: "1px solid #B0B0B0 !important",
            backgroundColor: "#fff",
            width: "700px", // 👈 set your custom width
            maxWidth: "90%",
            p: 0
          },
        }}
      >
        <DialogContent>
          {/* Title */}
          <Typography
            sx={{
              fontSize: "30px",
              fontWeight: 500,
              color: "#121212",
              mb: 3,
            }}
          >
            Tell us how you want to use Memorial Go
          </Typography>

          {/* Radio Options */}
          <RadioGroup
            row
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value === "true")}
            sx={{
              mb: 2,
              ml: 1,
              "& .MuiTypography-root": {
                color: "#4B4F50",
                fontSize: "14px",
                fontWeight: 500,
              },
              gap: "4px",
            }}
          >
            <FormControlLabel
              value={false}
              control={
                <Radio size="small"
                />
              }
              label="Buying for Self/Family"
              sx={{
                "& .MuiTypography-root": {
                  color: "#4B4F50",
                  fontSize: "14px",
                  fontWeight: "400 !important",
                },
                mr: 2,
                "& .MuiFormControlLabel-label": {
                  margin: 0,
                },
              }}
            />

            <FormControlLabel
              value={true}
              control={
                <Radio size="small"
                />
              }
              label="I am a Funeral Director"
              sx={{
                "& .MuiTypography-root": {
                  color: "#4B4F50",
                  fontSize: "14px",
                  fontWeight: "400 !important",
                },
                mr: 2,
                "& .MuiFormControlLabel-label": {
                  margin: 0,
                },
              }}
            />
          </RadioGroup>

          {/* Continue Button aligned right */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              disableElevation
              disabled={selectedRole === null}
              onClick={handleSaveRole}
              sx={{
                backgroundColor: "#EBD28D !important",
                color: "#104145 !important",
                borderRadius: "8px",
                px: 5,
                py: 1.2,
                fontWeight: 500,
                fontSize: "16px",
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#EBD28D !important",
                  boxShadow: "none",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#b3b2b2 !important",
                  color: "#fff !important",
                  cursor: "not-allowed !important",
                  pointerEvents: "auto !important",
                },
              }}
            >
              OK
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </Box>
  );
}
